export default __webpack_public_path__ + "static/media/performance_help.1b645e0f.jpeg";